import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Snackbar from 'components/Snackbar';
import { defaultTheme } from 'themes';
import { Button } from 'components/buttons';
import { useForm, useTranslation } from 'hooks';
import {
  Paper,
  Center,
  NavLinkActive,
  InputWrapper,
  Typo,
  FormFooter,
  BackLink,
  Message,
  LargeLink,
  Subtext
} from './../style';
import { FormContainer, FormItem, FormRow } from 'components/styledComponents';
import { TextField } from 'components/inputs';

function ForgotPasswordPage({ syncing, resetPwdStatus, onResetPassword, onInit }) {
  useEffect(() => {
    onInit();
  }, [onInit]);

  const { t } = useTranslation();
  const [errors, setErrors] = useState({});
  const { handleSubmit, useInput } = useForm({
    onSubmit: onResetPassword,
    validationSchema: 'forgotPasswordSchema'
  });
  const useInputVal = useInput('email');

  return (
    <Container maxWidth="xs">
      <Snackbar
        message={errors.request}
        open={!!errors.request}
        variant="error"
        onClose={() => setErrors({ request: null })}
      />
      <Paper>
        <Center>
          <NavLinkActive>{t('title.forgottenPassword')}</NavLinkActive>
        </Center>

        <FormContainer>
          {resetPwdStatus !== 'success' && (
            <FormRow>
              <FormItem component={InputWrapper}>
                <TextField
                  placeholder={t('label.emailAddress')}
                  required
                  {...useInputVal}
                  fullWidth
                />
              </FormItem>
            </FormRow>
          )}

          {resetPwdStatus && (
            <Typo>
              {/* Changed component="div" so we don’t nest <div> inside <p> */}
              <Typography component="div">
                {/* Pass $isError instead of isError to avoid DOM prop warning */}
                <Message $isError={resetPwdStatus !== 'success'}>
                  {t(
                    resetPwdStatus === 'success'
                      ? 'message.resetPwdSuccess'
                      : 'message.resetPwdError'
                  )}
                </Message>
              </Typography>
            </Typo>
          )}

          {!resetPwdStatus && (
            <FormFooter>
              <BackLink color={defaultTheme.color.primary.contrast} to="/login">
                {t('link.backToLogin')}
              </BackLink>
              <Button
                color="primary"
                variant="lightContained"
                disabled={syncing}
                label={t('button.retryPwdReset')}
                onClick={handleSubmit}
              />
            </FormFooter>
          )}

          {resetPwdStatus === 'success' && (
            <FormRow>
              {/* Renamed props to $fullWidth and $textAlign so they don’t leak to DOM */}
              <LargeLink $fullWidth $textAlign="center" size="large" to="/login">
                <Button
                  color="primary"
                  variant="lightContained"
                  disabled={syncing}
                  label={t('link.backToLogin')}
                />
              </LargeLink>
            </FormRow>
          )}

          <Subtext dangerouslySetInnerHTML={{ __html: t('message.supportMessage') }} />
        </FormContainer>
      </Paper>
    </Container>
  );
}

ForgotPasswordPage.propTypes = {
  resetPwdStatus: PropTypes.string,
  syncing: PropTypes.bool.isRequired,
  onInit: PropTypes.func.isRequired,
  onResetPassword: PropTypes.func.isRequired
};

export default ForgotPasswordPage;
